import type { FormFieldInterface } from "../dom/form";

export type FieldResolver = (identifier: string) => FormFieldInterface;

const handlers: Record<
  string,
  (
    identifier: string,
    action: string,
    resolver: FieldResolver,
    ...args: unknown[]
  ) => void
> = {
  ticketFields(identifier, action, resolver, ...args) {
    const field = resolver(identifier);
    switch (action) {
      case "hide":
        return field.hide();
      case "show":
        return field.show();
      case "hideOptions":
        return field.hideOptions(args[0] as string | string[]);
      case "showOptions":
        return field.showOptions(args[0] as string | string[]);
      case "resetOptions":
        return field.resetOptions();
      case "filterOptions":
        return field.filterOptions(args[0] as string | string[]);
      case "clearFilter":
        return field.clearFilter();
      default:
        throw new Error(`ticketFields: unknown action "${action}"`);
    }
  },
};

export function invoke(
  path: string,
  resolver: FieldResolver,
  ...args: unknown[]
): void {
  const colonIdx = path.indexOf(":");
  const dotIdx = path.lastIndexOf(".");

  if (colonIdx === -1 || dotIdx === -1 || dotIdx < colonIdx) {
    throw new Error(
      `Invalid invoke path: "${path}". Expected format: "namespace:identifier.action"`,
    );
  }

  const namespace = path.substring(0, colonIdx);
  const identifier = path.substring(colonIdx + 1, dotIdx);
  const action = path.substring(dotIdx + 1);

  const handler = handlers[namespace];
  if (!handler) throw new Error(`Unknown namespace: "${namespace}"`);

  handler(identifier, action, resolver, ...args);
}
